import { FilterDefinitionValue } from "@/pages/(app)/returns/hooks/use-filter-definitions";
import ConditionFilterCommand from "@/pages/(app)/returns/list/components/commands/condition-filter-command";
import DateFilterCommand from "@/pages/(app)/returns/list/components/commands/date-filter.command";
import FacetedFilter from "@/pages/(app)/returns/list/components/faceted-filter/faceted-filter";
import { DateFrontFilterValue } from "@/pages/(app)/returns/providers/return-requests-filters.provider";
import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import useTranslation from "@babackapp/translations/use-translation";
import { DateFilterName } from "../../utils/types";

interface DateFacetedFilterProps {
  filterDefinition: FilterDefinitionValue;
  filter: DateFrontFilterValue;
  filterName: DateFilterName;
}

export default function DateFacetedFilter({
  filterDefinition,
  filter,
  filterName,
}: DateFacetedFilterProps) {
  const t = useTranslation();
  const { clearFilter } = useReturnRequestsFilters();

  // Affichage de la plage de dates à partir du tableau value
  let dateLabel = "";
  if (filter.value?.length) {
    const from = filter.value[0] ? new Date(parseInt(filter.value[0])).toLocaleDateString() : "";
    const to = filter.value[1] ? new Date(parseInt(filter.value[1])).toLocaleDateString() : "";
    if (from && to) dateLabel = `${from} → ${to}`;
  }

  if (!dateLabel) {
    return <></>
  }

  return (
    <FacetedFilter
      categoryProps={{
        label: filterDefinition.category.label,
        Icon: filterDefinition.category.Icon,
      }}
      typeProps={{
        label: t(`misc.filters.between`),
        children: (
          <ConditionFilterCommand
            conditionsOptionValues={["between"]}
            value={filter.condition}
            filterKey={filterName}
          />
        ),
      }}
      valueProps={{
        label: dateLabel,
        icons: [],
        children: (
          <DateFilterCommand
            filterDefinition={filterDefinition}
            filter={filter}
            filterKey={filterName}
          />
        ),
      }}
      onClearClick={() => {
        clearFilter({ name: filterName });
      }}
    />
  );
}
